<template>
  <div class="base-info">
    <formTemplate :title="'基础信息'" :rules="rules" :formData="base_info">
      <template v-slot:body>
        <el-form-item label="商品名称" prop="goods_name">
          <el-input v-model="base_info.goods_name" placeholder="商品名称" /> <span class="primary-label">请填入详细商品名称</span>
        </el-form-item>

        <el-form-item label="货号" prop="item_no">
          <el-input v-model="base_info.item_no" placeholder="商品货号" /> <span class="primary-label">请填入详细商品货号</span>
        </el-form-item>
        <el-form-item label="分类编号" prop="class_no">
          <el-select style="width: 60%;" v-model="base_info.class_no" placeholder="请选择商品分类编号" filterable>
            <el-option v-for="item in class_list" :key="item.class_no" :label="item.class_name"
              :value="item.class_no" />
          </el-select><span class="primary-label">请选择商品类别</span>
        </el-form-item>

        <el-form-item label="品牌名称" prop="brand_name">
          <el-select style="width: 60%;" v-model="base_info.brand_name" multiple :multiple-limit="1" placeholder="品牌编号"
            filterable allow-create default-first-option>
            <el-option v-for="item in brand_list" :key="item.brand_name" :label="item.brand_name"
              :value="item.brand_name" />
          </el-select> <span class="primary-label">请选择品牌编号可创建 <span class="reda-text">最多1个</span></span>
        </el-form-item>
        <el-form-item label="产地" prop="product_area">
          <el-input v-model="base_info.product_area" placeholder="产地" /><span class="primary-label">请输入产地</span>
        </el-form-item>
        <el-form-item label="定义商品标签" prop="goods_tags">
          <el-select v-model="base_info.goods_tags" :multiple-limit="3" style="width: 60%;" multiple filterable
            allow-create default-first-option placeholder="选择/新建 商品标签">
            <el-option v-for="item in tag_options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select><span class="primary-label">可输入自定义标签，回车创建，<span class="reda-text">最多3个</span></span>
        </el-form-item>
        <el-form-item label="商品简介" prop="lable_content">
          <div class="primary-flex-colum">
            <span class="primary-label primary-flex" style="height: 20px;margin: 0;">商品简介推荐： <span class="reda-text">品牌
                + 品类词 + 利益点</span></span>
            <el-input v-model="base_info.lable_content" placeholder="导购标题" />
          </div>
        </el-form-item>

      </template>

    </formTemplate>

  </div>

</template>
<script>
import { onlinesGetClassifyList } from "@/api/onlines/goods.js";
import formTemplate from './formTemplate.vue';
export default {
  name: 'BaseInfo',
  components: {
    formTemplate
  },
  data() {
    return {
      class_list: [],
      brand_list: [], //品牌
      tag_options: [{
        label: "热销",
        value: "热销"
      }, {
        label: "千鹤",
        value: "千鹤"
      }, {
        label: "推荐",
        value: "推荐"
      }], //标签选项
      base_info: {
        goods_tags: [], //商品标签
        lable_content: '', //商品简介
        goods_name: '', //商品名称
        item_no: '', //货号
        class_no: '', //分类编号
        brand_name: '', //品牌
        product_area: ''
      },
      rules: {
        goods_name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        item_no: [
          { required: false, message: '请输入货号', trigger: 'blur' }
        ],
        class_no: [
          { required: true, message: '请选择分类编号', trigger: 'change' }
        ],
        brand_name: [
          { required: false, message: '请选择品牌名称', trigger: 'change' }
        ],
        product_area: [
          { required: false, message: '请输入产地', trigger: 'blur' }
        ],
        goods_tags: [
          { required: false, message: '请选择或创建商品标签', trigger: 'change' }
        ],
        lable_content: [
          { required: true, message: '请输入商品简介', trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    this.getClassifyList();
  },
  methods: {
    getValue() {
      return {
        ...this.base_info,
        brand_name: this.base_info[0]
      }
    },
    setValue(d) {
      this.base_info = d;
    },
    /**
     * 获取所有线上类别
     */
    async getClassifyList() {
      const res = await onlinesGetClassifyList();

      this.class_list = res;
      console.log(res);
    }
  }
};
</script>
<style lang="less" scoped>
.el-input {
  width: 60%;
}
</style>